import { render } from "./UltimateServiceItem.vue?vue&type=template&id=364bc604&scoped=true"
import script from "./UltimateServiceItem.vue?vue&type=script&lang=js"
export * from "./UltimateServiceItem.vue?vue&type=script&lang=js"

import "./UltimateServiceItem.vue?vue&type=style&index=0&id=364bc604&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364bc604"]])

export default __exports__